import { memo } from "react";
import { useDate } from "../hooks/useDate";
import "../styles/clock.css";

const Clock = memo(function Clock() {
  const { date, time } = useDate();
  
  return (
    <div className="clock-wrapper">

      <div className="clock-container">
        <span className="time">{time}</span>
        <span className="date">{date}</span>
      </div>

    </div>
  );
});

export default Clock;
